@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.override.shipmentSelectMenuList {
    max-height: 198px;
}

.scacImg {
    display: block;
    width: 20px;
    height: 20px;

    &.hidden {
        display: none;
    }
}

.placeholder {
    display: flex;
    align-items: center;
    gap: 8px;
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-900;
}